// userApi.ts
// Asegúrate de tener la variable de entorno definida en tu .env
const API_URL = `${window.location.protocol}//${window.location.hostname}`;

// Función para actualizar los datos del usuario actual
export const updateUserData = async (data: { nombre: string; emailnotificaciones: string; recibircorreos: boolean }) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/updateUser`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      nombre: data.nombre,
      emailnotificaciones: data.emailnotificaciones,
      recibircorreos: data.recibircorreos,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al actualizar los datos del usuario: ${errorText}`);
  }

  return response.json();
};


// Función para obtener los datos del usuario actual
export const getUserData = async () => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/getUserData/@me`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (response.status === 403 || response.status === 401) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    localStorage.removeItem('userId');
    window.location.href = '/login';
    throw new Error('Token expirado o inválido');
  }

  if (!response.ok) {
    throw new Error('Error al obtener los datos del usuario');
  }

  const data = await response.json();
  console.log('Datos del usuario desde el backend:', data);
  return data;
};


// API para subir o eliminar la imagen de perfil
export const updateProfilePic = async (file?: File, action: 'upload' | 'delete' = 'upload') => {
  const token = localStorage.getItem('authToken');
  const formData = new FormData();
  formData.append('action', action);

  if (file && action === 'upload') {
    formData.append('file', file);
  }

  const response = await fetch(`${API_URL}/api/profilePic`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`
    },
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al actualizar la imagen de perfil: ${errorText}`);
  }

  return response.json();
};


// Obtener lista de usuarios con filtros, paginación, etc.
// userApi.ts

// userApi.ts

export const fetchUsuarios = async (params: {
  search?: string;
  activo?: string;
  ordenarPor?: string;
  rol?: string;
  page: number;
  limit: number;
}) => {
  const token = localStorage.getItem('authToken');
  const queryParams = new URLSearchParams();

  if (params.search) queryParams.append('search', params.search);
  if (params.activo) queryParams.append('activo', params.activo);
  if (params.ordenarPor) queryParams.append('ordenarPor', params.ordenarPor);
  if (params.rol) queryParams.append('rol', params.rol);
  queryParams.append('page', params.page.toString());
  queryParams.append('limit', params.limit.toString());

  const response = await fetch(`${`${window.location.protocol}//${window.location.hostname}`}/api/usuarios?${queryParams.toString()}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al obtener la lista de usuarios: ${errorText}`);
  }

  return response.json();
};


export const createUsuario = async (usuario: any) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(usuario),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al crear el usuario: ${errorText}`);
  }

  return response.json();
};

// Actualizar un usuario existente por id_usuario
export const updateUsuario = async (id_usuario: string, usuario: any) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios/${encodeURIComponent(id_usuario)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(usuario),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al actualizar el usuario: ${errorText}`);
  }

  return response.json();
};

// Borrar un usuario por id_usuario
export const deleteUsuario = async (id_usuario: string) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios/${encodeURIComponent(id_usuario)}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al eliminar el usuario: ${errorText}`);
  }

  return response.json();
};


// Obtener los subusuarios del usuario actual
export const fetchSubusers = async () => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios/@me/subusuarios`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al obtener los subusuarios: ${errorText}`);
  }

  return response.json();
};

// Crear un nuevo subusuario
export const createSubuser = async (subuser: { nombre: string; email: string; login: string; password: string }) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios/@me/subusuarios`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(subuser),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al crear el subusuario: ${errorText}`);
  }

  return response.json();
};

// Actualizar un subusuario existente
export const updateSubuser = async (id_usuario: string, subuser: { nombre: string; email: string; login: string; password?: string }) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios/@me/subusuarios/${encodeURIComponent(id_usuario)}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(subuser),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al actualizar el subusuario: ${errorText}`);
  }

  return response.json();
};

// Eliminar un subusuario
export const deleteSubuser = async (id_usuario: string) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/api/usuarios/@me/subusuarios/${encodeURIComponent(id_usuario)}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error al eliminar el subusuario: ${errorText}`);
  }

  return response.json();
};